import { NoddiAsyncError } from 'noddi-types';
import { commonTexts, getInternalErrorMessage } from 'noddi-util';
import { ErrorPageBase } from '../../components/Elements/Errors/ErrorPageBase';

type ApiErrorPageInternal = {
  error: NoddiAsyncError | (NoddiAsyncError | null)[];
};

export const ApiErrorPageInternal = ({ error }: ApiErrorPageInternal) => {
  const { title, tryAgain } = commonTexts.errors;

  const descriptionError = getInternalErrorMessage(error);

  return (
    <ErrorPageBase
      title={title}
      description={descriptionError}
      buttonProps={{
        buttonText: tryAgain,
        onButtonClick: () => window.location.reload()
      }}
    />
  );
};
